import React from 'react';
import "../../styles/nep-syllabus/main.css";

const Main = () => {
    return (
        <section id="nepSyllabusMain">
            <div className="nep-main-section">
                <div className="container">
                    <div>
                        <h2 className="my-heading">Syllabus NEP-2020</h2>
                    </div>
                    <div className="table-div">
                        <p>
                            Syllabus according to New Education Policy (NEP) 2020 (with effect from
                            July 2021)
                        </p>
                        <table>
                            <thead>
                                <tr>
                                    <th>&nbsp;</th>
                                    <th className="text-start">Name of Subject</th>
                                    <th>Download</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>
                                        <strong>Botany</strong> :-
                                    </td>
                                    <td align="center" valign="middle">
                                        &nbsp;
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>
                                        B.Sc. - For First Three Years of Higher Education (UG)/ Minor
                                        Elective Papers
                                    </td>
                                    <td style={{ textAlign: "center" }} align="center" valign="middle">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className="float-none"
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/Botany-bsc-n.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>&nbsp;</td>
                                    <td align="center" valign="middle">
                                        &nbsp;
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>
                                        <strong>B.Com.</strong> w.e.f. 2021-22
                                    </td>
                                    <td style={{ textAlign: "center" }} align="center" valign="middle">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className="float-none"
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/BCom-commerce.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>&nbsp;</td>
                                    <td align="center" valign="middle">
                                        &nbsp;
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>
                                        <strong>B.Sc. </strong>Food Science &amp; Quality Control
                                    </td>
                                    <td style={{ textAlign: "center" }} align="center" valign="middle">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className="float-none"
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/bsc-food-science-quality-control-n.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>
                                        <strong>B.Sc.</strong> ( Ag.)/ <strong>B.Sc.</strong> (
                                        Ag.)&nbsp;Hons.
                                    </td>
                                    <td style={{ textAlign: "center" }} align="center" valign="middle">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className="float-none"
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/Bsc-Ag-Hons-n.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>&nbsp;</td>
                                    <td align="center" valign="middle">
                                        &nbsp;
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>
                                        <strong>Chemistry </strong>- B.Sc. (For First Three Years of
                                        Higher Education)
                                    </td>
                                    <td style={{ textAlign: "center" }} align="center" valign="middle">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className="float-none"
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/Chemistry-NEP-Syllabus-n.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>
                                        B.Sc. Industrial Chemistry (For First Three Years of Higher
                                        Education)
                                    </td>
                                    <td style={{ textAlign: "center" }} align="center" valign="middle">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className="float-none"
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/Ind-Chem.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>&nbsp;</td>
                                    <td align="center" valign="middle">
                                        &nbsp;
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>
                                        <strong>Chemistry</strong> :-
                                    </td>
                                    <td align="center" valign="middle">
                                        &nbsp;
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>
                                        Chemistry - B.Sc. (For First Three Years of Higher Education)
                                    </td>
                                    <td style={{ textAlign: "center" }} align="center" valign="middle">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className="float-none"
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/Chemistry-NEP-Syllabus-n.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>
                                        B.Sc. Industrial Chemistry (For First Three Years of Higher
                                        Education)
                                    </td>
                                    <td style={{ textAlign: "center" }} align="center" valign="middle">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className="float-none"
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/Ind-Chem.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>&nbsp;</td>
                                    <td align="center" valign="middle">
                                        &nbsp;
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>
                                        <strong>B.A. (Drawing and Painting)</strong> :-
                                    </td>
                                    <td align="center" valign="middle">
                                        &nbsp;
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>B.A. (Drawing and Painting)</td>
                                    <td style={{ textAlign: "center" }} align="center" valign="middle">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className="float-none"
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/BA-Drawing-Painting.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>
                                        <strong>Defence Studies</strong> :-
                                    </td>
                                    <td align="center" valign="middle">
                                        &nbsp;
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>Defence Studies (For First Three Years UG Programme)</td>
                                    <td style={{ textAlign: "center" }} align="center" valign="middle">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className="float-none"
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/Defence-Studies-UG.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>Proposed Syllabus Defence &amp; Strategic Studies</td>
                                    <td style={{ textAlign: "center" }} align="center" valign="middle">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className="float-none"
                                                href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/07/syl_defence_studies.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>&nbsp;</td>
                                    <td align="center" valign="middle">
                                        &nbsp;
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>
                                        <strong>Economics</strong> :-
                                    </td>
                                    <td align="center" valign="middle">
                                        &nbsp;
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>B.A. (For First Three Years of Higher Education)</td>
                                    <td style={{ textAlign: "center" }} align="center" valign="middle">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className="float-none"
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/Economics-BA.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>&nbsp;</td>
                                    <td align="center" valign="middle">
                                        &nbsp;
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>
                                        <strong>Education</strong> :-
                                    </td>
                                    <td align="center" valign="middle">
                                        &nbsp;
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>Education - B.A.</td>
                                    <td style={{ textAlign: "center" }} align="center" valign="middle">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className="float-none"
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/Education-BA.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>
                                        <strong>English</strong> :-
                                    </td>
                                    <td align="center" valign="middle">
                                        &nbsp;
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>
                                        B.A. (For First Three Years of Higher Education (UG) Programme)
                                    </td>
                                    <td style={{ textAlign: "center" }} align="center" valign="middle">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className="float-none"
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/English-BA.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>
                                        <strong>Fine Art</strong> :-
                                    </td>
                                    <td align="center" valign="middle">
                                        &nbsp;
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>Fine Art - B.A.</td>
                                    <td style={{ textAlign: "center" }} align="center" valign="middle">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className="float-none"
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/Fine-Art-BA.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>
                                        <strong>Geography</strong> :-
                                    </td>
                                    <td align="center" valign="middle">
                                        &nbsp;
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>Geography- B.A.</td>
                                    <td style={{ textAlign: "center" }} align="center" valign="middle">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className="float-none"
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/Geography-BA.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>
                                        <strong>Geology</strong> :-
                                    </td>
                                    <td align="center" valign="middle">
                                        &nbsp;
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>
                                        Geology- (For First Three Years of Higher Education (UG)
                                        Programme)
                                    </td>
                                    <td style={{ textAlign: "center" }} align="center" valign="middle">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className="float-none"
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/Geology-UG.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>
                                        <strong>Hindi</strong> :-
                                    </td>
                                    <td align="center" valign="middle">
                                        &nbsp;
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>B.A. (Hindi)</td>
                                    <td style={{ textAlign: "center" }} align="center" valign="middle">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className="float-none"
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/Hindi-BA.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>
                                        <strong>History</strong> :-
                                    </td>
                                    <td align="center" valign="middle">
                                        &nbsp;
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>B.A.</td>
                                    <td style={{ textAlign: "center" }} align="center" valign="middle">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className="float-none"
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/History-BA.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>
                                        <strong>Home Science</strong> :-
                                    </td>
                                    <td align="center" valign="middle">
                                        &nbsp;
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>
                                        B.A. (For First Three Years of Higher Education (UG) Programme)
                                    </td>
                                    <td style={{ textAlign: "center" }} align="center" valign="middle">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className="float-none"
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/Home-Science-BA.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>B.Sc. Home Science NEP (2024-25)</td>
                                    <td style={{ textAlign: "center" }} align="center" valign="middle">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className="float-none"
                                                href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/09/B.Sc%20HOME%20SCIENCE%20(NEP)-Ann-I.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>B.Sc. Home Science (CN &amp; D) NEP (2024-25)</td>
                                    <td style={{ textAlign: "center" }} align="center" valign="middle">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className="float-none"
                                                href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/09/B.Sc.%20Home%20Science%20(CN&D)%20NEP-Ann-II.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>M.Sc. HOME SCIENCE (HD) NEP (2024-25)</td>
                                    <td style={{ textAlign: "center" }} align="center" valign="middle">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className="float-none"
                                                href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/09/M.Sc.%20HD%20Syllabus%20(NEP)-Ann-V.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>M. A. HOME SCIENCE NEP (2024-25)</td>
                                    <td style={{ textAlign: "center" }} align="center" valign="middle">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className="float-none"
                                                href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/09/M.A.%20Syllabus%20(NEP%202020)-Ann-III.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>M.Sc. HOME SCIENCE (CLOTHING AND TEXTILES) NEP (2024-25)</td>
                                    <td style={{ textAlign: "center" }} align="center" valign="middle">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className="float-none"
                                                href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/09/M.Sc%20Clothing%20and%20textiles%20(NEP)-Ann-VI.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>MINOR ELECTIVE FOR P.G. PROGRAMME</td>
                                    <td style={{ textAlign: "center" }} align="center" valign="middle">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className="float-none"
                                                href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/09/Minor%20Elective%20for%20P%20G%20Programme-Ann-X.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>MINOR ELECTIVE FOR U.G. PROGRAMME</td>
                                    <td style={{ textAlign: "center" }} align="center" valign="middle">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className="float-none"
                                                href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/09/Minor%20Elective%20for%20U%20G%20Programme-Ann-IX.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>M.Sc. HOME SCIENCE (FOOD AND NUTRITION) NEP (2024-25)</td>
                                    <td style={{ textAlign: "center" }} align="center" valign="middle">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className="float-none"
                                                href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/09/MSc%20Food%20&%20Nutrition%20(NEP)-Ann-IV.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>
                                        <strong>Law</strong> - B.A./ B.Sc./ B.Com.
                                    </td>
                                    <td align="center" valign="middle">
                                        &nbsp;
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>
                                        <strong>Library and Information Science</strong> :-
                                    </td>
                                    <td align="center" valign="middle">
                                        &nbsp;
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>
                                        B.A. (For First Three Years of Under-Graduate (UG) Programme)
                                    </td>
                                    <td style={{ textAlign: "center" }} align="center" valign="middle">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className="float-none"
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/Library-Information-Science-BA.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>
                                        <strong>Mathematics</strong> - B.A./ B.Sc. (For First Three Years
                                        of Under-Graduate (UG) Programme)
                                    </td>
                                    <td align="center" valign="middle">
                                        &nbsp;
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>Mathematics - B.A./ B.Sc.</td>
                                    <td style={{ textAlign: "center" }} align="center" valign="middle">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className="float-none"
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/Mathematics-BA-BSc.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>
                                        <strong>Microbiology</strong> :-
                                    </td>
                                    <td align="center" valign="middle">
                                        &nbsp;
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>Industrial Microbiology</td>
                                    <td style={{ textAlign: "center" }} align="center" valign="middle">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className="float-none"
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/Industrial-Microbiology.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>
                                        Microbiology - B.Sc. (for Theory and Practical Papers Under
                                        Graduate Programme)
                                    </td>
                                    <td style={{ textAlign: "center" }} align="center" valign="middle">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className="float-none"
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/Microbiology-BSc.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>
                                        <strong>Music</strong> :-
                                    </td>
                                    <td align="center" valign="middle">
                                        &nbsp;
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>B.A. Music Sitar / Music Tabla/ Music Vocal</td>
                                    <td style={{ textAlign: "center" }} align="center" valign="middle">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className="float-none"
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/Music-BA.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>
                                        <strong>Philosophy</strong> B.A.
                                    </td>
                                    <td align="center" valign="middle">
                                        &nbsp;
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>Philosophy B.A.</td>
                                    <td style={{ textAlign: "center" }} align="center" valign="middle">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className="float-none"
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/Philosophy-BA.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>
                                        <strong>Physics</strong> - B.Sc. (For First Three Years of
                                        Under-Graduate (UG) Programme)
                                    </td>
                                    <td align="center" valign="middle">
                                        &nbsp;
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>Physics - B.Sc.</td>
                                    <td style={{ textAlign: "center" }} align="center" valign="middle">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className="float-none"
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/Physics-BSc.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>
                                        <strong>Physical Education</strong> :-
                                    </td>
                                    <td align="center" valign="middle">
                                        &nbsp;
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>B.A.</td>
                                    <td style={{ textAlign: "center" }} align="center" valign="middle">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className="float-none"
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/Physical-Education-BA.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>
                                        <strong>Political Science</strong> :-
                                    </td>
                                    <td align="center" valign="middle">
                                        &nbsp;
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>B.A.</td>
                                    <td style={{ textAlign: "center" }} align="center" valign="middle">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className="float-none"
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/Political-Science-BA.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>
                                        <strong>Psychology</strong> B.A.
                                    </td>
                                    <td align="center" valign="middle">
                                        &nbsp;
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>Psychology B.A.</td>
                                    <td style={{ textAlign: "center" }} align="center" valign="middle">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className="float-none"
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/Psychology-BA.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>
                                        <strong>Sanskrit</strong> - B.A. (For First Three Years of
                                        Under-Graduate (UG) Programme)
                                    </td>
                                    <td align="center" valign="middle">
                                        &nbsp;
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>Sanskrit (Spoken)</td>
                                    <td style={{ textAlign: "center" }} align="center" valign="middle">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className="float-none"
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/Sanskrit-Spoken.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>Sanskrit /Jyotish</td>
                                    <td style={{ textAlign: "center" }} align="center" valign="middle">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className="float-none"
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/Sanskrit-Jyotish.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>Yog Science</td>
                                    <td style={{ textAlign: "center" }} align="center" valign="middle">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className="float-none"
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/Yog-Science.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>
                                        <strong>Sociology</strong> :-
                                    </td>
                                    <td align="center" valign="middle">
                                        &nbsp;
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>B.A. Sociology (New Updated)</td>
                                    <td style={{ textAlign: "center" }} align="center" valign="middle">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className="float-none"
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/Sociology-New-Updated-BA.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>
                                        B.A. (Common Minimum Syllabus for first 3 years B.A. in Sociology)
                                    </td>
                                    <td style={{ textAlign: "center" }} align="center" valign="middle">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className="float-none"
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/Sociology-Common-Minimum-BA.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>
                                        Social Work - B.A.(Common Minimum Syllabus for first 3 years B.A.
                                        in Social Work)
                                    </td>
                                    <td style={{ textAlign: "center" }} align="center" valign="middle">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className="float-none"
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/Social-Work-BA.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>
                                        <strong>Statistics</strong> - B.Sc. (For First Three Years of
                                        Under-Graduate (UG) Programme)
                                    </td>
                                    <td align="center" valign="middle">
                                        &nbsp;
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>Statistics - B.Sc.</td>
                                    <td style={{ textAlign: "center" }} align="center" valign="middle">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className="float-none"
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/Statistics-BSc.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>
                                        <strong>Urdu</strong> - B.A.
                                    </td>
                                    <td align="center" valign="middle">
                                        &nbsp;
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>Urdu - B.A.</td>
                                    <td style={{ textAlign: "center" }} align="center" valign="middle">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className="float-none"
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/Urdu-BA.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>
                                        <strong>Vedic Mathematics</strong>: One Year Certificate Course in
                                        Vedic Mathematics
                                    </td>
                                    <td align="center" valign="middle">
                                        &nbsp;
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>
                                        Vedic Mathematics: One Year Certificate Course in Vedic
                                        Mathematics
                                    </td>
                                    <td style={{ textAlign: "center" }} align="center" valign="middle">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className="float-none"
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/Vedic-Mathematics.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>
                                        <strong>Zoology</strong> :-
                                    </td>
                                    <td align="center" valign="middle">
                                        &nbsp;
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>
                                        B.Sc. (For First Three Years of Under-Graduate (UG) Programme)
                                    </td>
                                    <td style={{ textAlign: "center" }} align="center" valign="middle">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className="float-none"
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/Zoology-BSc.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </section>

    )
}

export default Main;